import type { InputHTMLAttributes, ReactNode } from 'react';
import { cn } from './cn';

/**
 * DESIGN.md › search-field: a fully round 48px field with a leading magnifier (passed in: the
 * kit ships no icons). `label` is the placeholder and the accessible name both — the design
 * shows no label above it. With focus the border is the 2px teal of input-focus.
 */
export function SearchField({
  label,
  icon,
  className,
  ...props
}: Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  label: string;
  icon?: ReactNode;
  className?: string;
}) {
  return (
    <label
      className={cn(
        'flex min-h-tap-target w-full items-center gap-internal-lg rounded-full border border-border-strong bg-surface pr-internal-md pl-internal-lg focus-within:border-2 focus-within:border-border-highlight',
        className,
      )}
    >
      {icon}
      <input
        type="search"
        aria-label={label}
        placeholder={label}
        autoComplete="off"
        {...props}
        className="h-tap-target min-w-0 flex-1 bg-transparent font-brand text-body-md text-on-surface outline-none placeholder:text-on-surface-weak"
      />
    </label>
  );
}
